import { useTranslation } from 'next-i18next'
import { makeStyles, Container } from '@material-ui/core'
import T from '../home-new/tokens'
import Reveal from '../home-new/Reveal'

// Section 4 — "เลือกวิธีใช้งาน SHIPPOP BUSINESS": three white cards, each a
// PNG method icon + brand-blue title + muted desc + dark pill link button.

const cards = [
  {
    id: 'system',
    icon: '/static/img/home-business/methods/system.png',
    href: '#contact-form',
  },
  {
    id: 'api',
    icon: '/static/img/home-business/methods/api.png',
    href: '#connect',
  },
  {
    id: 'plugin',
    icon: '/static/img/home-business/methods/plugin.png',
    href: '#connect',
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.canvas,
    [theme.breakpoints.down('sm')]: {
      padding: '44px 0',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 700,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 44px',
    '& span': { color: T.color.brand },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      margin: '0 0 28px',
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '28px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '18px',
    },
  },
  card: {
    background: T.color.surface,
    borderRadius: 24,
    boxShadow: T.shadow.card,
    padding: '36px 28px 32px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 16px 36px rgba(0,102,204,0.14)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '30px 22px 26px',
    },
  },
  iconWrap: {
    height: 96,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 18,
    '& img': {
      maxHeight: 96,
      maxWidth: 140,
      objectFit: 'contain',
    },
  },
  cardTitle: {
    fontFamily: T.font.heading,
    fontSize: 21,
    fontWeight: 600,
    color: T.color.brand,
    margin: '0 0 12px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  cardDesc: {
    fontFamily: T.font.body,
    fontSize: 15,
    color: T.color.muted,
    lineHeight: 1.7,
    margin: '0 0 26px',
    flexGrow: 1,
  },
  cardBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    padding: '0 26px',
    borderRadius: T.radius.pill,
    background: T.color.ink,
    color: T.color.onBrand,
    fontFamily: T.font.heading,
    fontSize: 15,
    fontWeight: 500,
    textDecoration: 'none',
    transition: 'transform 0.2s ease, background 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      background: T.color.brandDeep,
      color: T.color.onBrand,
    },
  },
}))

const MethodsBiz = () => {
  const classes = useStyles()
  const { t } = useTranslation('business')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            {t('methods.headingPre')} <span>SHIPPOP BUSINESS</span>
          </h2>
        </Reveal>
        <div className={classes.grid}>
          {cards.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.12}>
              <div className={classes.card}>
                <span className={classes.iconWrap}>
                  <img src={c.icon} alt="" aria-hidden="true" loading="lazy" />
                </span>
                <h3 className={classes.cardTitle}>{t(`methods.items.${c.id}.title`)}</h3>
                <p className={classes.cardDesc}>{t(`methods.items.${c.id}.desc`)}</p>
                <a href={c.href} className={classes.cardBtn}>
                  {t(`methods.items.${c.id}.cta`)}
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default MethodsBiz
